"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttSlider(props) {
  return /*#__PURE__*/_react["default"].createElement(_Slider["default"], props);
}
var _default = SttSlider;
exports["default"] = _default;